import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FooterPrimaryComponent } from '../../components/footer-primary/footer-primary.component';
import { NavbarPrimaryComponent } from '../../components/navbar-primary/navbar-primary.component';
import {
  FooterContentService,
  FooterDocument
} from '../../services/footer-content.service';

@Component({
  selector: 'app-reference-documents',
  imports: [RouterLink, NavbarPrimaryComponent, FooterPrimaryComponent],
  templateUrl: './reference-documents.component.html',
  styles: `
    :host {
      height: 100vh;
      display: flex;
      flex-direction: column;
    }

    main {
      flex: 1;
      padding-top: 64px;
    }
  `
})
export class ReferenceDocumentsComponent {
  private readonly footerContent = inject(FooterContentService);

  buttonCollapsed: boolean[] = [];

  files: FooterDocument[] = [];
  loading = true;
  error = false;

  constructor() {
    this.footerContent.getDocuments('reference_documents').subscribe({
      next: (files) => {
        this.files = files;
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      }
    });
  }
}
